import React, { Component } from 'react';
import { connect } from "react-redux";
import {METRONOME_BUTTON} from 'constants/contextual-help.js';
import Documented from 'components/help/Documented.js';

class ClockComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            clockDragging: false,
            clockStartDragY: undefined,
            clockDragY: undefined,
        };
    }

    onClockMouseLeave(e) {
        if (this.seekTimer != undefined) {
            clearInterval(this.seekTimer);
            this.seekTimer = undefined;
        }
    }

    onClockMouseDown(e) {
        if (this.props.sequencerEngine === undefined) {
            return;
        }
        this.state.clockStartDragY = e.clientY;
        this.seekTimer = setInterval(() => {
            if (this.state.clockDragY !== undefined) {
                let acceleration = this.state.clockStartDragY - this.state.clockDragY;
                let trackStep = this.props.sequencerEngine.trackStep + acceleration * 5;
                if (trackStep < 0) {
                    trackStep = 0;
                }
                this.props.sequencerEngine.seekToTrackStep(trackStep);
            }
        }, 50);
    }

    onClockMouseUp(e) {
        clearInterval(this.seekTimer);
        this.seekTimer = undefined;
    }

    onClockMouseMove(e) {
        this.state.clockDragY = e.clientY;
    }

    onClickMetronome() {
        if (this.props.sequencerEngine === undefined) {
            return;
        }
        this.props.sequencerEngine.metronomeOn =
            !this.props.sequencerEngine.metronomeOn;
    }

    render() {
        let trackStep = Math.ceil(this.props.currentGlobalStep / 32);
        trackStep = isNaN(trackStep) ? 1 : trackStep;
        let currentQuarterStep = 1 + (Math.floor(this.props.currentGlobalStep / 8) % 4);
        let currentSixteenthStep = 1 + (Math.floor(this.props.currentGlobalStep / 2) % 4);

        let clockClassName = "clock ";
        if (this.props.clockTick) {
            clockClassName += 'percentage-' + this.props.clockTick;
        }

        let metronomeClassName = "metronome";
        if (this.props.metronomeOn) {
            if ((this.props.currentGlobalStep / 4) % 4 >= 2) {
                metronomeClassName += " off-beat";
            } 
            metronomeClassName += " on";
        }
        return (
            <div
              className={clockClassName}
              onMouseLeave={(event) => this.onClockMouseLeave(event)}
              onMouseDown={(event) => this.onClockMouseDown(event)}
              onMouseUp={(event) => this.onClockMouseUp(event)}
              onMouseMove={(event) => this.onClockMouseMove(event)}>
              <div className="track-time">{trackStep}</div>
              <div className="divider">.</div>
              <div className="time">{currentQuarterStep}</div>
              <div className="divider">.</div>
              <div className="time">{currentSixteenthStep}</div>
              <Documented
                element={METRONOME_BUTTON}
                onClick={() => this.onClickMetronome()}
                className={metronomeClassName}>
                <div className="dot first"></div>
                <div className="dot second"></div>
              </Documented>
            </div>
        );
    }
}
const mapStateToProps = (state, props) => {
    if (props.sequencerEngine === undefined) {
        return {
            currentStep: 0,
            currentGlobalStep: 0,
            clockTick: 0,
            metronomeOn: false
        };
    }
    let id = props.sequencerEngine.getSequenceId();
    let currentStep = state.sequencer.currentStep[id] || 0;
    let currentGlobalStep = state.sequencer.currentGlobalStep[id] || 0;
        
    return {
        currentStep: currentStep,
        currentGlobalStep: currentGlobalStep,
        clockTick: state.clock.clockTick,
        metronomeOn: props.sequencerEngine.metronomeOn
    };
};


export default connect(mapStateToProps, null)(ClockComponent);
